<div class="file-row" [class.failed]="state === 'failed'">
  <i class="fas {{ iconClass }} file-icon" aria-hidden="true"></i>
  <span class="file-name" [title]="fileName">{{ fileName }}</span>
  <span *ngIf="sizeLabel" class="file-size">{{ sizeLabel }}</span>
  <span *ngIf="state === 'failed' && errorMessage" class="file-error" [title]="errorMessage">{{ errorMessage }}</span>
  <span class="file-row-spacer"></span>
  <span
    *ngIf="state === 'uploading'"
    class="spinner-border spinner-border-sm file-spinner"
    role="status"
    [attr.aria-label]="'AI_PARSER_UPLOADING' | translate"
  ></span>
  <span class="file-actions">
    <ng-content select="[file-row-actions]"></ng-content>
  </span>
</div>
